import React, {useEffect} from "react";
import {Route, Redirect} from "react-router";
import PropTypes from "prop-types";
import {isPWA} from "../../utils/url";

const RedirectToURL = ({url}) => {
    const isPWAFlag = isPWA(url);

    useEffect(() => {
        if (!isPWAFlag) {
            window.location.href = url;
        }
    }, [url, isPWAFlag]);

    if (!isPWAFlag) {
        return null;
    }
    return (
        <Route
            render={({staticContext}) => {
                if (staticContext) {
                    staticContext.url = url;
                }
                return <Redirect to={url} />;
            }}
        />
    );
};
RedirectToURL.propTypes = {
    url: PropTypes.string,
};
export default RedirectToURL;
